import type { UserSurvey } from "@jti/rest-api-types";

export type GetSurveysByType = (surveys: UserSurvey[]) => {
  oneTimeSurveys: UserSurvey[];
  recurringSurveys: UserSurvey[];
};

export const getSurveysByType: GetSurveysByType = (surveys) => {
  return surveys.reduce<{ oneTimeSurveys: UserSurvey[]; recurringSurveys: UserSurvey[] }>(
    (acc, survey) => {
      if (survey.type === "one_time") {
        acc.oneTimeSurveys.push(survey);
      } else if (survey.type === "recurring") {
        acc.recurringSurveys.push(survey);
      }
      return acc;
    },
    { oneTimeSurveys: [], recurringSurveys: [] }
  );
};
